import React from 'react';
import DesignUsage from './DesignUsage';
import EngineeringUsage from './EngineeringUsage';
import Library from './Library';
import styles from './icons.module.scss';

const Icons = () => (
  <section className={styles.iconsSection}>
    <header>
      <h1 id="icons">Icons</h1>
    </header>
    <p>Icons are used to support a label or trigger an interaction within the user interface.</p>
    <p>
      To use the icons, the font must be installed on your computer. Find it here: frontend/fonts
      <mark>/raiseme-icons.ttf.</mark>
    </p>

    <DesignUsage />
    <EngineeringUsage />
    <Library />
  </section>
);

export default Icons;
